import { Card, Col, Row } from "antd";
import "./chronicBreakdown.scss";
import TopFilters from "./TopFilters/topFilter";
import Filters from "./filters/filter";
import ChronicConditionsChart from "./chronicBreakdownChart";

const ChronicBreakdownReport = () => {
  
  return (
    <div className="chronic-breakdown-report">
      <div className="chronic-breakdown-report__header mb-1">
        <div className="chronic-breakdown-report__header__title">Chronic Breakdown Dashboard</div>
        <div className="chronic-breakdown-report__header__filter">
          <TopFilters />
        </div>
      </div>
      <div className="chronic-breakdown-report__body">
        <Row>
          <Col span={7}>
            <Filters />
          </Col>
          <Col span={17}>
            <Card className="ml-05">
              <ChronicConditionsChart />
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};
export default ChronicBreakdownReport;